import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQueryWithAuth = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + "api/",
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        headers.set('Content-Type', 'application/json');
        return headers;
    },
    responseHandler: async (response) => {
        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (error) {
            if (!response.ok) {
                throw new Error(text);
            }
            return text;
        }
    },
});

export const newsEngApi = createApi({
    reducerPath: 'newsEngApi',
    baseQuery: baseQueryWithAuth,
    tagTypes: ['News'],
    endpoints: (builder) => ({
        createNewEng: builder.mutation({
            query: (news) => ({
                url: '/NewsEng/CreatNewEng',
                method: 'POST',
                body: news,
            }),
            invalidatesTags: [{ type: 'News', id: 'LIST' }],
        }),
        updateNewEng: builder.mutation({
            query: (news) => ({
                url: `/NewsEng/UpdateNewEng`,
                method: 'PUT',
                body: news,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'News', id }],
        }),
        getNewEngById: builder.query({
            query: (id) => `/NewsEng/GetNewEng?id=${id}`,
            providesTags: (result, error, id) => [{ type: 'News', id }],
        }),
        getAllNewsEng: builder.query({
            query: ({ pageSize, pageIndex }) => `/NewsEng/GetAllNewsEng?pageSize=${pageSize}&pageIndex=${pageIndex}`,
            providesTags: (result) =>
                result ?
                    [...result.map(({ id }) => ({ type: 'News', id })), { type: 'News', id: 'LIST' }]
                    : [{ type: 'News', id: 'LIST' }],
        }),
        deleteNewEngById: builder.mutation({
            query: (id) => ({
                url: `/NewsEng/DeleteNewAll?id=${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'News', id }, { type: 'News', id: 'LIST' }],
        }),
    }),
});

export const {
    useCreateNewEngMutation,
    useUpdateNewEngMutation,
    useGetNewEngByIdQuery,
    useGetAllNewsEngQuery,
    useDeleteNewEngByIdMutation
} = newsEngApi;